import React from "react";
import { Redirect } from "react-router-dom";
import { useAuthDispatch } from "Contexts/Auth";
import { clearAuthStorage } from "Utils/authUtils";
import auth from "Api/auth";

const Logout = () => {
  const dispatch = useAuthDispatch();
  auth.useLogout();
  dispatch({
    type: "loggedOut",
  });
  clearAuthStorage();
  return <Redirect to="/login" />;
};

export default Logout;
